<template>
  <div style="height: 100vh;">
    <iframe class="airtable-embed" src="https://fckpoor-nfc.carrd.co" frameborder="0"
      onmousewheel="" width="100%" height="100%"
      style="background: transparent; border: 1px solid #ccc;"></iframe>
  </div>
</template>

<script>
export default {
};
</script>
